import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { attachJwtInterceptor, validateInitialAuthSession } from 'utils/jwtInterceptor';
import MainRoutes from './Routes/MainRoutes';
import * as serviceWorkerRegistration from 'utils/serviceWorkerRegistration';
import { BrowserRouter } from 'react-router-dom';

// Validasi token autentikasi di awal: jika expired, bersihkan storage & cookies segera
validateInitialAuthSession();

// Pastikan axios default selalu terpasang JWT Bearer interceptor
attachJwtInterceptor(axios);

ReactDOM.render(
    <BrowserRouter>
        <MainRoutes />
    </BrowserRouter>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorkerRegistration.register();
